<div class="main-content">
  <div class="view-container">
    <ng-content></ng-content>
  </div>
</div>
